import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { endOfApiScale, startOfApiScale } from '@library/store/measures/measures';
import { EnumApiScales, TimeRange } from '@library/store/measures/measures.interface';
import { DateAdapter } from '@angular/material/core';
import { firstValueFrom } from 'rxjs';
import { UserFacade } from '@library/store/user/user.facade';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-day-picker',
  templateUrl: './day-picker.component.html',
  styleUrls: ['./day-picker.component.scss']
})
export class DayPickerComponent implements OnInit {

  date = new FormControl();

  @Input() value: TimeRange;
  @Output() valueChange = new EventEmitter<TimeRange>();

  @Input() touchUi = false;

  @Input() minDate = moment('2011');
  @Input() maxDate = null;

  constructor(
    private dateAdapter: DateAdapter<moment.Moment>,
    private userFacade:UserFacade) {

   }

  async ngOnInit() {
    const locale = await firstValueFrom(this.userFacade.locale$)
    this.dateAdapter.setLocale(locale);
    this.date.valueChanges.subscribe((date: moment.Moment) => {
      this.valueChange.next({
        dateBegin: startOfApiScale(date.clone(), EnumApiScales.FIVE_MINUTES),
        dateEnd: endOfApiScale(date.clone(), EnumApiScales.FIVE_MINUTES),
      });
    })

    this.date.patchValue(this.value.dateBegin, {emitEvent: false})
  }

  ngOnChanges() {
    if (this.value) {
      this.date.patchValue(this.value.dateBegin.clone().add('5', 'm'), {emitEvent: false})
    }
  }

}
